import { apiEndpoint } from './apiEndpoint';
import { standardHeaders } from './standardHeaders';

export async function deleteSkill(skillId: string) {
	const response = await fetch(`${apiEndpoint}/skills/${skillId}`, {
		method: 'DELETE',
		headers: await standardHeaders(),
		mode: 'cors'
	});
	if (response.ok) {
		return await response.json();
	}
	return null;
}